import { ISwAppVirtualAccountTransferRefundsApi } from "../../interfaces-and-types";

type TRefundsUrls = {
  [key in keyof ISwAppVirtualAccountTransferRefundsApi]: string;
};

const rootRefundsUrl = "/virtual-account-transfer-refunds";

export const virtualAccountTransferRefundsUrls: TRefundsUrls = {
  getVirtualAccountTransferRefundsList: `${rootRefundsUrl}`,
  getVirtualAccountTransferRefundById: `${rootRefundsUrl}/id`,

  acceptPaymentIssueAsPartialPayment: `${rootRefundsUrl}/id/accept-as-partial`,
  settlePaymentIssueToMerchantBalance: `${rootRefundsUrl}/id/settle-to-balance`,
  redirectPaymentIssueToInvoice: `${rootRefundsUrl}/id/redirect-to-invoice`,
  refundPaymentIssueToCustomer: `${rootRefundsUrl}/id/refund-to-customer`,
};
